import { ICustomProperties, IEventTelemetry } from "@microsoft/applicationinsights-web";
import { UserIdentity } from "shared/models/UserIdentity";
import { GrantEnum } from "view360Card/models/GrantEnum";

export class UserOpenedApplicationEvent implements IEventTelemetry {
    name: string = "UserOpenedApplicationEvent";
    userIdentity: UserIdentity | null;
    userObjectId: string | undefined;
    userPrincipalName: string | undefined;

    constructor(
        userIdentity: UserIdentity | null,
        userObjectId: string | undefined,
        userPrincipalName: string | undefined,
    ) {
        this.userIdentity = userIdentity;
        this.userObjectId = userObjectId;
        this.userPrincipalName = userPrincipalName;
    }

    public getCustomProperties = (): ICustomProperties => {
        return {
            teamsUserObjectId: this.userObjectId,
            teamsUserPrincipalName: this.userPrincipalName,
            branchCode: this.userIdentity?.branchCode,
            businessRole: this.userIdentity?.businessRole,
            email: this.userIdentity?.email,
            fullName: this.userIdentity?.fullName,
            userName: this.userIdentity?.userName,
            grants: JSON.stringify(this.userIdentity?.grants.map(g => GrantEnum[g]))
        };
    };
}
